module.exports = __webpack_public_path__ + "static/media/arrow.a7d6fc16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/arrow.svg
// module id = 81
// module chunks = 0